<div class="date-badge">
  <div class="date-badge-month font-caption-small font-semi-bold" [class.span-months]="hasMonthSpan()">
    <span class="date-badge-shimmer" [appShimmer]="isLoading()" [appShimmerWidthRem]="1.5">
      @if (hasMonthSpan()) {
        {{ startDate() | date:'MMM' }}-{{ endDate() | date:'MMM' }}
      } @else {
        {{ startDate() | date:'MMM' }}
      }
    </span>
  </div>

  <div class="font-label-small font-bold">
    <span class="date-badge-shimmer" [appShimmer]="isLoading()" [appShimmerWidthRem]="0.85">
      @if (hasDaySpan()) {
        {{ startDate() | date:'d' }}-{{ endDate() | date:'d' }}
      } @else {
        {{ startDate() | date:'d' }}
      }
    </span>
  </div>

  <div class="date-badge-year font-caption-small font-medium" [class.span-months]="hasMonthSpan()">
    <span class="date-badge-shimmer" [appShimmer]="isLoading()" [appShimmerWidthRem]="1.5">
      @if (hasYearSpan()) {
        {{ startDate() | date:'y' }}-{{ endDate() | date:'yy' }}
      } @else {
        {{ startDate() | date:'y' }}
      }
    </span>
  </div>
</div>
